import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=6387f36c&scoped=true&"
import script from "./Integration.vue?vue&type=script&lang=js&"
export * from "./Integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6387f36c",
  null
  
)

export default component.exports